// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    ICartItem,
}                               from '../interfaces';

const getUserCartItems = async ({
    test,
}: {
    test: boolean,
}): Promise<ICartItem[] | null> => {
    const functions = getFunctions();
    const handleGetUserCartItems = httpsCallable<
        Record<
            string,
            boolean
        >,
        ICartItem[] | null
    >(
        functions,
        'getUserCartItems',
    );
    return handleGetUserCartItems({
        test,
    }).then((result) => {
        const cartItems = result.data as ICartItem[] | null;
        return cartItems;
    }).catch((err) => {
        throw err;
    });
};

export default getUserCartItems;
